import { render, staticRenderFns } from "./ZoomProperty.vue?vue&type=template&id=66593300&"
import script from "./ZoomProperty.vue?vue&type=script&lang=js&"
export * from "./ZoomProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports